<template>
  <div class="columns is-centered is-multiline">
    <div class="column is-8">
      <component :is="currentQuestion" class="columns is-multiline" @done="onStepDone"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'QuestionnaireWrapper',
  data() {
    return {
      previousQuestion: null,
      currentQuestion: null,
      finalData: {}
    }
  },
  methods: {
    onStepDone(result) {
      const { key, selectedOption, stepData, isFinal } = result;

      let dataToStore = {}

      if (selectedOption) {
        const { label, value, component } = selectedOption;
        this.previousQuestion = this.currentQuestion;
        this.currentQuestion = component;

        dataToStore = {
          ...dataToStore,
          label,
          value
        }
      }

      if (stepData) {
        dataToStore.data = stepData;
      }

      this.finalData[key] = dataToStore;

      if (isFinal) {
        this.sendData(result);
      }
    },
    goBack() {
      this.currentQuestion = this.previousQuestion;
    },
    sendData(result) {
      axios
      .post('https://jcjjde6dh8.execute-api.us-east-1.amazonaws.com/Prod/trigger/user', {
        data: result
      }).then( data => {
        console.log(data)
      }).catch(err => {
        console.error(err)
      })
    }
  },
  beforeMount() {
    this.currentQuestion = 'QuestionnaireStart'
  }
}
</script>
